import { render } from "./taohaobangHome.vue?vue&type=template&id=36c2f8d3&scoped=true"
import script from "./taohaobangHome.vue?vue&type=script&lang=js"
export * from "./taohaobangHome.vue?vue&type=script&lang=js"

import "./taohaobangHome.vue?vue&type=style&index=0&id=36c2f8d3&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c2f8d3"]])

export default __exports__